import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

const storedToken = localStorage.getItem("hg_token");
if (storedToken) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in

  useEffect(() => {
    const token = localStorage.getItem("hg_token");
    if (!token) {
      setUser(false);
      return;
    }
    axios
      .get(`${API}/api/auth/me`)
      .then((res) => setUser(res.data.user))
      .catch(() => {
        localStorage.removeItem("hg_token");
        delete axios.defaults.headers.common["Authorization"];
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password });
    localStorage.setItem("hg_token", data.token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    sessionStorage.setItem("hg_show_director", "1");
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hg_token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
